exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".message-container[data-v-6250eb00] {\n  margin: 10px !important;\n  max-width: 550px !important;\n}\n", ""]);

// exports
